import Cookies from 'js-cookie'
import {FREQUENCY_CAP} from '../context/gameplayer-ads-context/gameplayer-ads-context'

const throttleCookie = 'throttle-ad'

const throttleAdFrequency = () => {
  const delayInDays = FREQUENCY_CAP / (24 * 60 * 60) // convert 45 seconds to days
  Cookies.set(throttleCookie, 'true', {expires: delayInDays, secure: true})
}

const checkIfAdIsFrequencyCapped = (): boolean => {
  const midRollCookieValue = Cookies.get(throttleCookie)
  if (midRollCookieValue) {
    return true
  }
  return false
}

export {throttleAdFrequency, checkIfAdIsFrequencyCapped}
